import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { Header, ToggleInput } from "@datagame/ui";
import { ChangeEvent } from "react";

import { Section } from "../../../Common";
import { Game } from "../../../../../../../../gql/graphql";
import { isSwiperGame } from "../../../../../../../../graphql/helpers/SwiperGame";
import { TooltipWithIcon } from "../../../../../../../shared/ui/TooltipWithIcon";

import styles from "./PointsSection.module.scss";
import { isQuickPickGame } from "../../../../../../../../graphql/helpers/isQuickPickGame";

const cx = classNames.bind(styles);

export interface PointsSectionProps {
  points: number;
  isCorrect: boolean;
  showPoints?: boolean;
  onUpdatePoints: (points: number) => void;
  onToggleCorrect: (isCorrect: boolean) => void;
  game: Game;
}

export interface PointProps {
  item: number;
  onUpdate: (points: number) => void;
  isSelected: boolean;
}

export const Point = ({ item, onUpdate, isSelected }: PointProps) => {
  return (
    <div
      onKeyDown={() => onUpdate(item)}
      role="button"
      tabIndex={0}
      onClick={() => onUpdate(item)}
      key={item}
      className={cx("point", { isSelected })}
    >
      <Header color={isSelected ? "white" : "orange"} variant="h5">
        {item}
      </Header>
    </div>
  );
};

export const PointsSection = ({
  game,
  points,
  isCorrect,
  onUpdatePoints,
  onToggleCorrect,
  showPoints = true,
}: PointsSectionProps) => {
  const { t } = useTranslation();
  const array = Array.from(Array(10).keys());

  const handleToggleCorrect = (event: ChangeEvent<HTMLInputElement>) => {
    onToggleCorrect(event.target.checked);
  };

  const isSwiper = isSwiperGame(game);
  const showIsCorrect = isSwiper || isQuickPickGame(game);
  const isCorrectCaption = isSwiper
    ? t("leaderboard:correctAnswerOnTheRight")
    : t("leaderboard:correctAnswerQuickPick");
  const tooltipCaption = isSwiper
    ? t("leaderboard:correctAnswerOnTheRightTooltip")
    : t("leaderboard:correctAnswerQuickPickTooltip");

  return (
    <>
      {showPoints && (
        <Section
          className={styles.pointsSection}
          title={t("leaderboard:points")}
          tooltip={<TooltipWithIcon content={t("leaderboard:pointsTooltip")} />}
        >
          <div className={styles.points}>
            {array.map((item) => {
              return <Point key={item} item={item + 1} onUpdate={onUpdatePoints} isSelected={points === item + 1} />;
            })}
          </div>
        </Section>
      )}

      {showIsCorrect && (
        <ToggleInput
          label={isCorrectCaption ?? ""}
          name="correctAnswerOnTheRight"
          value={isCorrect}
          onChange={handleToggleCorrect}
          tooltip={<TooltipWithIcon content={tooltipCaption} />}
        />
      )}
    </>
  );
};
